import { useProperty } from '@spotify-internal/remote-config-integration-react';

import { hindiMessagingBool } from 'utils/remote-config/properties';

const useHindiMessagingUnavailable = (locale: string) => {
  const isHindiMessaging = useProperty(hindiMessagingBool, { loadingValue: false });
  return locale === 'hi-IN' && !isHindiMessaging;
};

export default useHindiMessagingUnavailable;
